import { render, staticRenderFns } from "./farmersDetail.vue?vue&type=template&id=afd844b0&scoped=true"
import script from "./farmersDetail.vue?vue&type=script&lang=js"
export * from "./farmersDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd844b0",
  null
  
)

export default component.exports